import { render, staticRenderFns } from "./icon-renderer.vue?vue&type=template&id=2087fbef&scoped=true"
import script from "./icon-renderer.vue?vue&type=script&lang=js"
export * from "./icon-renderer.vue?vue&type=script&lang=js"
import style0 from "./icon-renderer.vue?vue&type=style&index=0&id=2087fbef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2087fbef",
  null
  
)

export default component.exports